import styles from "./generative-ai-style-modal.module.css";
import { Button, clsx, Heading, Modal, RadioGroup, RadioOption } from "@gemlightbox/core-kit";
import { useStores } from "src/hooks";
import { useRef, useState } from "react";
import { observer } from "mobx-react-lite";
import { ModalExtendedType } from "src/store";
import standard_closeup from "src/external-ts/assets/images/edit-media/generative-ai-style/standard_closeup.jpg";
import fashion_magazine_style from "src/external-ts/assets/images/edit-media/generative-ai-style/fashion_magazine_style.jpg";
import luxury_gala_look from "src/external-ts/assets/images/edit-media/generative-ai-style/luxury_gala_look.jpg";
import lifestyle_casual_elegance from "src/external-ts/assets/images/edit-media/generative-ai-style/lifestyle_casual_elegance.jpg";
import minimalist_studio_focus from "src/external-ts/assets/images/edit-media/generative-ai-style/minimalist_studio_focus.jpg";
import beauty_influencer_style from "src/external-ts/assets/images/edit-media/generative-ai-style/beauty_influencer_style.jpg";
import high_jewelry_loose_stone_showcase from "src/external-ts/assets/images/edit-media/generative-ai-style/high_jewelry_loose_stone_showcase.jpg";

export type GenerativeAiStyleModalProps = ModalExtendedType<{
  onConfirm?: (value: string) => void;
}>;

export const GenerativeAiStyleModal: React.FC<GenerativeAiStyleModalProps> = observer(
  ({ isOpen, setClose, onFinalClosed, options }) => {
    const { localeStore } = useStores();
    const [selectedOption, setSelectedOption] = useState("standard_closeup");
    enum AIModelImageStyle {
      StandardCloseup = "standard_closeup",
      // FashionMagazineStyle = "fashion_magazine_style",
      // LuxuryGalaLook = "luxury_gala_look",
      // LifestyleCasualElegance = "lifestyle_casual_elegance",
      MinimalistStudioFocus = "minimalist_studio_focus",
      // BeautyInfluencerStyle = "beauty_influencer_style",
      // HighJewelryLooseStoneShowcase = "high_jewelry_loose_stone_showcase",
    }

    const images = {
      standard_closeup,
      fashion_magazine_style,
      luxury_gala_look,
      lifestyle_casual_elegance,
      minimalist_studio_focus,
      beauty_influencer_style,
      high_jewelry_loose_stone_showcase,
    };

    type ImageKeys = keyof typeof images;

    const handleConfirm = () => {
      if (options.onConfirm) {
        options.onConfirm?.(selectedOption);
      } else {
        setClose();
      }
    };

    return (
      <Modal
        data-cy="generative-ai-style-modal"
        contentClassName={styles.container}
        name="generative-ai-style-modal"
        setClose={setClose}
        onFinalClosed={onFinalClosed}
        isOpen={isOpen}
        disablePadding
        disableBorderRadius
        withCross
      >
        <Heading className={styles.header} tag="h2" color="textSecondary">
          {localeStore.t('["edit-media"]["generative-ai-style"].title')}
        </Heading>
        <div className={styles.content}>
          <div className={styles.imageContainer}>
            <img
              className={styles.image}
              src={images[selectedOption as ImageKeys]}
              alt={selectedOption}
            />
          </div>
          <RadioGroup
            className={styles.aiRadioGroup}
            value={selectedOption}
            onChange={(value) => setSelectedOption(value as string)}
            disableError
          >
            {Object.values(AIModelImageStyle).map((value) => (
              <RadioOption
                key={value}
                value={value}
                className={clsx(styles.aiRadioOption, {
                  [styles.selected]: selectedOption === value,
                })}
                disabled={value === "minimalist_studio_focus"}
              >
                <span
                  className={clsx("", {
                    [styles.radioDisabledLabel]: value === "minimalist_studio_focus",
                  })}
                >
                  {localeStore.t(`["edit-media"]["generative-ai-style"].${value}` as any)}
                </span>
                {value === "minimalist_studio_focus" && (
                  <div className={styles.coming_soon_tag}>
                    {localeStore.t('["edit-media"]["generative-ai"].coming_soon_tag')}
                  </div>
                )}
              </RadioOption>
            ))}
          </RadioGroup>
        </div>
        <div className={styles.buttons}>
          <Button
            appearance="primary"
            className={styles.confirmBtn}
            onClick={handleConfirm}
            data-cy="gem-ai-style-confirm"
          >
            {localeStore.t("common.buttons.confirm")}
          </Button>
        </div>
      </Modal>
    );
  },
);
